import { getMonthlyPrice, hasMonthlyPrice, getMonthlyPriceRecurrenceEnd } from './price-helpers';
import { formatEuro } from './format-euro';

export const PROMO_ONLINE_BENEFIT = 'onlineBenefit';

export function getPromoSubprices (offer: any): Array<any> {
    const runtimes = [];

    for (const service of offer.getDiscounts()) {
        if (service.description) {
            if (service.description.additional) {
                if (service.description.additional.type === PROMO_ONLINE_BENEFIT) {
                    continue;
                }
            }
        }

        if (hasMonthlyPrice(service.prices)) {
            if (runtimes.indexOf(getMonthlyPriceRecurrenceEnd(service.prices)) < 0) {
                runtimes.push(getMonthlyPriceRecurrenceEnd(service.prices));
            }
        }
    }

    const subprices = [];

    for (const runtime of runtimes) {
        const startMonth = runtime - 1;

        subprices.push({
            runtime: runtime + 1,
            price: offer.getMonthlyPriceAfterNMonths(runtime)
        });
    }

    return subprices;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-promo-subprices.ts